import React from 'react';
import Card from '../../models/card';

import './card-item.scss';

type Props = {
  card: Card;
  feedback: string;
  handleCard: (card: Card) => void;
  toggleModal: (imgUrl: string) => void;
};

function CardItem(props: Props) {
  return (
    <li className={`card-item ${props.feedback}`} onClick={() => props.handleCard(props.card)}>
      <div className="card-item-front">
        <img className="card-item-img" src={props.card.imgUrl} alt="" />
        <button className="card-item-button" onClick={() => props.toggleModal(props.card.contentUrl)}>
          more
        </button>
      </div>
      <img className="card-item-back" src="assets/back.png" alt="" />
    </li>
  );
}

export default CardItem;
